import global$1 from './global.js';
import toIntegerOrInfinity$1 from './to-integer-or-infinity.js';
import toString$1 from './to-string.js';
import requireObjectCoercible$1 from './require-object-coercible.js';

var global = global$1;
var toIntegerOrInfinity = toIntegerOrInfinity$1;
var toString = toString$1;
var requireObjectCoercible = requireObjectCoercible$1;
var RangeError = global.RangeError; // `String.prototype.repeat` method implementation
// https://tc39.es/ecma262/#sec-string.prototype.repeat

var stringRepeat = function repeat(count) {
  var str = toString(requireObjectCoercible(this));
  var result = '';
  var n = toIntegerOrInfinity(count);
  if (n < 0 || n == Infinity) throw RangeError('Wrong number of repetitions');

  for (; n > 0; (n >>>= 1) && (str += str)) if (n & 1) result += str;

  return result;
};

export { stringRepeat as default };
